import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import style from './NovoGrupoDeUsuario.module.css'
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GrupoDeUsuarioApi from "../../services/GrupoDeUsuarioApi";
import { Form } from "react-bootstrap";
import Alerta from "../../components/alerta/Alerta";
import BotaoSalvar from "../../components/botaoSalvar/BotaoSalvar";
import Loader from "../../components/loader/Loader";
import InputBuscar from "../../components/inputBuscar/InputBuscar";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";

function NovoGrupoDeUsuario() {
  const isMobile = useIsMobile();
  const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

  useEffect(() => {
    setMenuHamburguerAberto(!isMobile);
  }, [isMobile]);
  const [nome, setNome] = useState("");
  const [descricao, setdescricao] = useState("");
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [mensagemAlerta, setMensagemAlerta] = useState("");
  const [tipoAlerta, setTipoAlerta] = useState("");

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const exibirAlerta = (mensagem, tipo) => {
    setMensagemAlerta(mensagem);
    setTipoAlerta(tipo);
    setMostrarAlerta(true);

  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      if (isFormValid()) {

        setLoading(true);
        const response = await GrupoDeUsuarioApi.CriarGrupoDeUsuarioAsync(nome, descricao);

        const novoGrupoId = response;
        exibirAlerta("Grupo de usuário criado com sucesso!", "success");
        setTimeout(() => {
          navigate("/backoffice/Permissoes", { state: { id: novoGrupoId } });
        }, 1000);

      } else {
        exibirAlerta("Por favor, preencha todos os campos.", "warning");
      }
    } catch (error) {
      exibirAlerta(
        `Erro ao adicionar o grupo de usuário: ${error.response?.data || "Erro desconhecido"
        }`,
        "danger"
      );
    } finally {
      setLoading(false);
    }
  };

  const isFormValid = () => {
    return nome && descricao;
  };

  return (
    <Sidebar menuHamburguerAberto={menuHamburguerAberto}
      setMenuHamburguerAberto={setMenuHamburguerAberto}>
      <Topbar
        menuHamburguerAberto={menuHamburguerAberto}
        setMenuHamburguerAberto={setMenuHamburguerAberto}
      >
        <Alerta
          tipo={tipoAlerta}
          mensagem={mensagemAlerta}
          visivel={mostrarAlerta}
          aoFechar={() => setMostrarAlerta(false)}
        />
        {loading && <Loader />}
        <div className={style.pagina_conteudo}>
          <h4>Novo Grupo de Usuário</h4>

          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formNome" className="mb-3">
              <Form.Label>Nome</Form.Label>
              <InputBuscar
                maxLength={100}
                type="text"
                placeholder="Digite o nome do grupo"
                name="nome"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="formDescricao" className="mb-3">
              <Form.Label>Descrição</Form.Label>
              <InputBuscar
                maxLength={200}
                type="text"
                placeholder="Digite a descrição do grupo"
                name="descricao"
                value={descricao}
                onChange={(e) => setdescricao(e.target.value)}
                required
              />
            </Form.Group>

            <BotaoSalvar isDisabled={!isFormValid()} />
          </Form>
        </div>
      </Topbar>
    </Sidebar>
  );
}

export default NovoGrupoDeUsuario;
